<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'branch/index' }">
                                Cabang
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'branch/view', params: {id: pattern.branchProgram.branchID} }">
                                {{ pattern.branchProgram.branch.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-if="roleElligibleModified()" v-bind:to="{ name: 'branch/program/edit', params: {id: pattern.branchProgram.branchID, programID: pattern.branchProgramID} }">
                                {{ pattern.branchProgram.grade.name }} - {{ pattern.branchProgram.programType.name }}
                            </router-link>
                            <router-link v-else v-bind:to="{ name: 'branch/view', params: {id: pattern.branchProgram.branchID} }">
                                {{ pattern.branchProgram.grade.name }} - {{ pattern.branchProgram.programType.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Kelas
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col mt-2">
                <h4 class="text-danger font-weight-bold mb-3">Kelas</h4>
                <div class="row">
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Cabang</h4>
                        <p class="font-weight-bold mb-0">{{ pattern.branchProgram.branch.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Kelas</h4>
                        <p class="font-weight-bold mb-0">{{ pattern.branchProgram.grade.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <h4 class="mb-1 text-muted font-weight-medium">Tipe Program</h4>
                        <p class="font-weight-bold mb-0">{{ pattern.branchProgram.programType.name }}</p>
                    </div>
                    <div class="col-auto mb-3">
                        <div class="row">
                            <div class="col-auto">
                                <h4 class="mb-1 text-muted font-weight-medium">Hari Pola</h4>
                                <p class="font-weight-bold mb-0" v-for="period in pattern.periods" v-bind:key="period.id">
                                    {{ $moment.weekdays(period.day) }}
                                </p>
                            </div>
                            <div class="col-auto">
                                <h4 class="mb-1 text-muted font-weight-medium">Sesi Pola</h4>
                                <p class="font-weight-bold mb-0" v-for="period in pattern.periods" v-bind:key="period.id">
                                    {{ [period.start, "HH:mm:ss"] | moment("HH.mm") }} - {{ [period.end, "HH:mm:ss"] | moment("HH.mm") }} ({{ period.slots }})
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-end" v-if="roleElligibleModified()">
            <div class="col-auto mt-1 mb-4">
                <button class="btn btn-outline-danger btn-sm font-weight-medium mb-2 px-5 mr-2" v-on:click="modal.upload = true">
                    Upload Data Kelas
                </button>
                <button class="btn btn-danger btn-sm font-weight-medium mb-2 px-5" v-on:click="modal.create = true">
                    Create New Kelas
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-12" v-for="(branchClass, index) in pattern.branchClasses">
                <form v-on:submit.prevent="edit($event, index)" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <router-link v-bind:to="{name: 'branch/program/pattern/class/view', params: {id: pattern.branchProgram.branchID, programID: pattern.branchProgramID, patternID: pattern.id, classID: branchClass.id}}" class="h4 font-weight-medium text-white mb-0">
                                        {{ branchClass.name }}
                                    </router-link>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModifiedStaff()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0 mr-2" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                        <!--<button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="confirmation(branchClass)">
                                            Delete
                                        </button>-->
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-1 align-items-center wrapper-input">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Kelas</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.branchClasses[index].name" disabled class="form-control toggle-input h4 mb-0 font-weight-medium form-control-sm" required/>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center wrapper-input">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Kapasitas</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.branchClasses[index].capacity" disabled type="number" class="form-control toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="edit-action">
                                <div class="row mb-1 align-items-center">
                                    <div class="col p-1">
                                        <label class="font-weight-medium h4 mb-0">Kapasitas Saat Ini</label>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center" v-for="(capacityAttribute, index) in capacityAttributes">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted h4 mb-0 form-divider">Semester {{ index + 1 }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <label class="font-weight-medium h4 mb-0">{{ branchClass[capacityAttribute] }}/{{ branchClass.capacity }}</label>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col p-1">
                                        <label class="font-weight-medium h4 mb-0">Link Zoom</label>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center" >
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.branchClasses[index].zoom" disabled class="form-control toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center wrapper-input">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider ">Link Zoom</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.branchClasses[index].zoom" disabled class="form-control toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <b-modal v-if="roleElligibleModified()" v-model="modal.create" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Create New Kelas
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="create">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-1">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Kelas</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.branchClass.name" class="form-control h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Kapasitas</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.branchClass.capacity" type="number" class="form-control h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-outline-danger btn-sm px-5">
                                Ya
                            </button>
                            <button type="button" class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.create = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-if="roleElligibleModified()" v-model="modal.upload" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Upload Data Kelas
                </h4>
            </template>
            <div class="container">
                <form v-on:submit.prevent="upload">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <div class="row mb-2 align-items-center">
                                <div class="col text-right">
                                    <a v-bind:href="'/static/template/data-sample-branch-class.csv?timestamp=' + $moment(new Date).format('X')" class="mb-0 small">
                                        Download Template
                                    </a>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 px-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">File</label>
                                </div>
                                <div class="col-lg-7 px-1">
                                    <input id="file" type="file" class="form-control" v-on:change="fileUpload" placeholder="Choose File" accept=".xlsx, .xls, .csv" required/>
                                    <label for="file" class="form-control form-control-sm text-truncate">
                                        <button type="button" class="btn btn-danger font-weight-bold">
                                            Choose File
                                        </button>
                                        {{ form.upload.branchClass.name }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button type="submit" class="btn btn-danger btn-sm px-5">
                                Submit
                            </button>
                            <button class="btn btn-outline-danger btn-sm px-5 ml-3" type="button" v-on:click="modal.upload = false">
                                Batal
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal v-if="roleElligibleModified()" v-model="modal.remove" v-on:hide="removeReference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus Kelas dalam pola ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button type="button" class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button type="button" class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.remove = false">
                            Batal
                        </button>        
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import Paginate from 'vuejs-paginate';
    import { mapState } from 'vuex';

    export default {
        name: "BranchProgramPatternView",
        components: {
            Paginate
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    branchClasses: [],
                    branchClass: {name: '', capacity: '', zoom: ''},
                    upload: {branchClass: ''}
                },
                pattern: {branchProgram: {branch: {}, grade: {}, programType: {}}},
                capacityAttributes: ['currentCapacity', 'secondCurrentCapacity', 'thirdCurrentCapacity', 'fourthCurrentCapacity'],
                modal: {
                    create: false,
                    upload: false,
                    remove: false
                },
                removeReference: null
            };
        },
        methods: {
            confirmation(model) {
                this.modal.remove = true;
                this.removeReference = model;
            },
            edit(event, index) {
                this.axios.post(process.env.API_URL + '/branch-class/update/' + this.pattern.branchClasses[index].id, this.form.branchClasses[index]).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            create() {
                this.axios.post(process.env.API_URL + '/branch-class', Object.assign(this.form.branchClass, {patternID: this.pattern.id})).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.create = false;
                        this.form.branchClass = {name: '', capacity: ''};
                        this.fetchPattern();
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            upload() {
                var formData = new FormData();
                for (var attribute in this.form.upload) {
                    formData.set(attribute, this.form.upload[attribute]);
                }
                formData.set('patternID', this.pattern.id);
                this.axios.post(process.env.API_URL + '/branch-class/upload', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.modal.upload = false;
                        this.fetchPattern();
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            remove() {
                if (this.removeReference) {
                    this.axios.post(process.env.API_URL + '/branch-class/delete/' + this.removeReference.id).then(response => {
                        if (response.data.status) {
                            this.$toastr('success', response.data.message, 'Success');
                            this.modal.remove = false;
                            this.removeReference = null;
                            this.fetchPattern();
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                    });
                }
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.fetchPattern();
                    }
                } else {
                    this.fetchPattern();
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            fileUpload(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.upload.branchClass = input.files[0];
                }
            },
            fetchPattern() {
                this.axios.get(process.env.API_URL + '/pattern/' + this.$route.params.patternID).then(response => {
                    this.pattern = response.data.data;

                    this.form.branchClasses = this.pattern.branchClasses;

                    document.title = 'Kelas - ' + this.pattern.branchProgram.grade.name + ' - ' + this.pattern.branchProgram.programType.name + " | " + this.pattern.branchProgram.branch.name + ' - ' + process.env.APP_NAME;
                });
            },
            roleElligibleModified() {
                return this.profile.isAdmin ;
            },
	    roleElligibleModifiedStaff() {
                return this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee.isBranchStaff);
            }
        },
        created() {
            this.fetchPattern();
            document.title = process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{ display: none; }
    .btn.btn-outline-white { border-color: #fff; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }

    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

    form[disabled] select.form-control-plaintext { -moz-appearance: none; -webkit-appearance: none; appearance: none; }
    form[disabled] label.required:after { display: none; }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }
</style>


// WEBPACK FOOTER //
// src/components/branch/program/pattern/View.vue